import 'bootstrap/js/dist/scrollspy';
import 'parsleyjs';
import 'slick-carousel';
import 'jquery-doubletaptogo';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-hoverintent';
import 'jquery-lazy';
import SlimSelect from 'slim-select';
import Handlebars from 'handlebars/runtime';
import ComparisonHelper from './helpers/comparison-helper';
import FormSubmission from './forms/form-submission';
import 'electro-privacy';

// components/views
import './components/mobile-nav';
import './components/mega-nav';

import ContentNavScroll from './components/content-nav-scroll';
import './components/search';
// used in templates
/* eslint-disable-next-line no-unused-vars */
import SocialWidget from './components/social-widget';

// Register handlebars partials
import moduleWYSIWYG from './templates/layouts/module_wysiwyg.hbs';
import moduleFootnotes from './templates/layouts/module_footnotes.hbs';
import moduleList from './templates/layouts/module_list.hbs';
import moduleTestimonials from './templates/layouts/module_testimonials.hbs';
import moduleTile from './templates/layouts/module_tile.hbs';
import moduleVideo from './templates/layouts/module_video.hbs';
import moduleSeparator from './templates/layouts/module_separator.hbs';

// Register handlebars helpers
Handlebars.registerHelper('ifEquals', ComparisonHelper.ifEquals);
Handlebars.registerPartial('module_wysiwyg', moduleWYSIWYG);
Handlebars.registerPartial('module_footnotes', moduleFootnotes);
Handlebars.registerPartial('module_list', moduleList);
Handlebars.registerPartial('module_testimonials', moduleTestimonials);
Handlebars.registerPartial('module_tile', moduleTile);
Handlebars.registerPartial('module_video', moduleVideo);
Handlebars.registerPartial('module_separator', moduleSeparator);
Handlebars.registerHelper('imageQuality', () => {
    return Electro.imageQuality ? Electro.imageQuality : 85;
});

/// ////////////////////////////////////////////////////////////////////////////
// Routes
/// ////////////////////////////////////////////////////////////////////////////
const { pathname } = window.location;
const $body = $('body');

(async () => {
    if ($body.hasClass('home')) {
        const { default: HomepageSlider } = await import(
            /* webpackChunkName: "homepage-slider" */
            './components/homepage-slider'
        );

        const homepageSlider = new HomepageSlider();
    } else if ($body.hasClass('single-cp_product')) {
        const { default: ProductDetail } = await import(
            /* webpackChunkName: "product-detail" */
            './pages/product-detail'
        );
        /* eslint-disable no-unused-vars */
        const productDetail = new ProductDetail();
        const { default: RelatedItemsSlider } = await import(
            /* webpackChunkName: "slideshow-related-items" */
            './views/slideshow-related-items'
        );
        /* eslint-disable no-unused-vars */
        const relatedItemsSlider = new RelatedItemsSlider();
    } else if ($body.hasClass('single-recipe')) {
        const { default: RelatedItemsSlider } = await import(
            /* webpackChunkName: "slideshow-related-items" */
            './views/slideshow-related-items'
        );
        /* eslint-disable no-unused-vars */
        const relatedItemsSlider = new RelatedItemsSlider();
    } else if (pathname === '/products/') {
        const { default: ProductArchive } = await import(
            /* webpackChunkName: "product-archive" */
            './pages/product-archive'
        );
        /* eslint-disable no-unused-vars */
        const productArchive = new ProductArchive();
    } else if (pathname === '/recipes/') {
        const { default: RecipeArchive } = await import(
            /* webpackChunkName: "recipe-archive" */
            './pages/recipe-archive'
        );
        /* eslint-disable no-unused-vars */
        const recipeArchive = new RecipeArchive();
    } else if (pathname === '/mix-and-match/') {
        const { default: SixForSixty } = await import(
            /* webpackChunkName: "6-for-60" */
            './pages/6-for-60'
        );
        /* eslint-disable no-unused-vars */
        const sixForSixty = new SixForSixty();
    } else if (pathname === '/how-to-buy/') {
        const { default: HowToBuy } = await import(
            /* webpackChunkName: "how-to-buy" */
            './pages/how-to-buy'
        );
        /* eslint-disable no-unused-vars */
        const howToBuy = new HowToBuy();
    }
})().catch((error) => {
    // Handle/report error
    /* eslint-disable no-console */
    console.error(error);
});

/// ////////////////////////////////////////////////////////////////////////////
// Modules
/// ////////////////////////////////////////////////////////////////////////////

if ($('.accordion-to-tab').length) {
    const { default: ResourcesPanel } = await import(
        /* webpackChunkName: "panel-resources" */
        './views/panel-resources'
    );
    const resourcesPanel = new ResourcesPanel();
}

if ($('.js-view-switcher').length) {
    const { default: ViewSwitcher } = await import(
        /* webpackChunkName: "view-switcher" */
        './components/view-switcher'
    );
    const viewSwitcher = new ViewSwitcher();
}

if ($('.js-image-over-video').length) {
    const { default: ImageOverVideo } = await import(
        /* webpackChunkName: "image-over-video" */
        './components/image-over-video'
    );
    const imageOverVideo = new ImageOverVideo();
}

if ($('.slim-select').length) {
    $('.slim-select').each((i, el) => {
        new SlimSelect({
            select: el,
            showSearch: true, // needed to have keyboard support
            onChange: () => {
                if ($(el).parsley) {
                    $(el).parsley().validate();
                }
            },
        });
    });
}

if (document.querySelector('form.form_generic')) {
    new FormSubmission();
}

/// /////////////////////////////////////////////////////////////////////////////
// Sticky navigation
/// /////////////////////////////////////////////////////////////////////////////
if ($('.header-global .sticky-wrapper').length > 0) {
    const { default: StickyNav } = await import(
        /* webpackChunkName: "sticky-nav" */
        './components/sticky-nav'
    );
    const stickyNav = new StickyNav();
}

/// /////////////////////////////////////////////////////////////////////////////
// Search Form
/// /////////////////////////////////////////////////////////////////////////////
if ($('.search-form').length > 0) {
    const { default: SearchUI } = await import(
        /* webpackChunkName: "search-ui" */
        './components/search-ui'
    );
    const searchUI = new SearchUI();
    searchUI.init();
}

/// /////////////////////////////////////////////////////////////////////////////
// Init Slideshows
/// /////////////////////////////////////////////////////////////////////////////
if ($('.slick-slider.slider--peekaboo').length > 0) {
    const { default: ProductSlider } = await import(
        /* webpackChunkName: "slideshow-products" */
        './views/slideshow-products'
    );
    $('.slick-slider.slider--peekaboo').each((i, el) => {
        const productSlider = new ProductSlider(el);
    });
}

/// /////////////////////////////////////////////////////////////////////////////
// Common Functions
/// /////////////////////////////////////////////////////////////////////////////
$('.js-scroll-to-top').click((e) => {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 });
});

$('nav').on('click', '.js-close', (e) => {
    e.preventDefault();
    const $el = $(e.currentTarget);
    const $container = $el.closest('nav');
    $container.removeClass('active');
});

if ($('.lazy').length) {
    // general lazy loading
    window.lazyOptions = {
        scrollDirection: 'vertical',
        effect: 'fadeIn',
        effectTime: 200,
        threshold: 800,
        visibleOnly: true,
        onError(element) {
            console.log(`error loading ${element.data('src')}`);
        },
    };
    $(() => {
        $('.lazy').Lazy(window.lazyOptions);
    });
}

/// /////////////////////////////////////////////////////////////////////////////
// Forms
/// /////////////////////////////////////////////////////////////////////////////

// Overlabel style toggle
$('body').on('focus', '.overlabel', (e) => {
    const $el = $(e.currentTarget);
    $el.addClass('active');
});
$('body').on('blur', '.overlabel', (e) => {
    const $el = $(e.currentTarget);
    const $field = $el.find('input');
    if (!$.trim($field.val())) {
        $field.val('');
        $el.removeClass('active');
    } else {
        $el.addClass('active');
    }
});

/// /////////////////////////////////////////////////////////////////////////////
// Smoothly scroll to target element
/// /////////////////////////////////////////////////////////////////////////////
if (document.querySelector('.js-content-nav') && document.querySelector('#content-nav')) {
    new ContentNavScroll();
}

/// /////////////////////////////////////////////////////////////////////////////
// OneTrust
/// /////////////////////////////////////////////////////////////////////////////
$(document).ready(() => {
    document.getElementById("do-not-share").addEventListener("click", () => {
        // eslint-disable-next-line no-undef
		if (typeof OneTrust !== "undefined") {
            // eslint-disable-next-line no-undef
			OneTrust.ToggleInfoDisplay();
		}
	});
});